// Centralized "session expired / unauthorized" handler.
//
// Anything that detects an invalid or expired session — a 401 from an /api/*
// call, or the periodic /__app/me re-check (see AuthWatcher) — funnels through
// here. We hit /__app/logout (which clears the session cookie server-side) and
// then land on the login page with a `return` path so the user resumes exactly
// where they were after signing in again.
//
// Guarded so concurrent 401s don't trigger multiple navigations.
import { clearAllRecentPatients } from './recentPatients.js'

let loggingOut = false

export function forceLogout() {
  if (loggingOut) return
  loggingOut = true
  clearAllRecentPatients() // don't leave one user's recent patients for the next
  const ret = window.location.pathname + window.location.search
  // location.replace → the expired page doesn't linger in history.
  window.location.replace(`/__app/logout?return=${encodeURIComponent(ret)}`)
}
